import * as Rellax from 'rellax'
import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import * as SmoothScroll from 'smooth-scroll'

gsap.registerPlugin(ScrollTrigger);

export default function common() {
  
  if(document.getElementsByClassName('rellax').length > 0){
    const rellax = new Rellax('.rellax',{
      center:true
    });
  }
  if(document.getElementsByClassName('rellax-no').length > 0){
    const rellax_no = new Rellax('.rellax-no',{
      center:false
    })
  }

  const scroll = new SmoothScroll('a[href*="#"], [data-scroll]',{
    header: '#site-header',
    offset: 0,
    speed: 1000,
    easing: 'easeInOutQuart',
    speedAsDuration: true,
    durationMin: 1000
  })


  const siteHeader = document.getElementById('header-app')
  if(siteHeader){
    ScrollTrigger.create({
      trigger: '#scrollArea',
      start: "top top-=15%",
      end: "bottom top",
      scrub: 1,
      once: false,
      invalidateOnRefresh: true,
      //markers: true,
      toggleClass: { targets: siteHeader, className: "active" },
    })
  }

  gsap.utils.toArray('.toAnimation').forEach((el, index) => {
    ScrollTrigger.create({
      trigger: el,
      start: "top center+=15%",
      end: "bottom center",
      toggleClass: { targets: el, className: "active" },
      once: true,
      //markers: true,
    });
  })

  gsap.utils.toArray('.toAnimationAll').forEach((el, index) => {
    ScrollTrigger.create({
      trigger: el,
      start: "top center+=15%",
      end: "bottom center",
      toggleClass: { targets: el, className: "active" },
      once: true,
      //markers: true,
    });
  })

}

